export const checkIfUserHasAllNecessaryPermissions = (
    listOfNecessaryPermissions: string[] | undefined,
    userPermissions: string[],
) => {
    if (!listOfNecessaryPermissions || listOfNecessaryPermissions.length === 0) {
        return true;
    }

    for (let i = 0; i < listOfNecessaryPermissions.length; i++) {
        const permission = listOfNecessaryPermissions[i];
        if (userPermissions.indexOf(permission) < 0) {
            return false;
        }
    }

    return true;
};
